import Vue from 'vue'
import App from './App.vue'
import '@/assets/style/global.css'
import element from "@/element-ui"
Vue.use(element)
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')
